import React, { useRef } from "react";
import { message } from "antd";
import { ICardcaseFormFields } from "../cardcaseService";
import { useCardcaseModel } from "../cardcaseModel";
import { IYhFormRef, FormItemTypeEnum, IYhForm, ISelectOption } from "@/components/YhFormBox/Types";
import { getFormValidatorErrText } from "@/utils/utils";
import { YHDrawer } from "@/components/YhDrawer";
import { YhForm } from "@/components/YhFormBox";


export function DetailDrawer() {
    const { cardcaseDrawer: { visible, mode }, dataGroupSource, setICardcaseDrawer, editCardcase, addCardcase, getSelectedRowData } = useCardcaseModel();
    const formRef = useRef<IYhFormRef>();
    const formVal = mode === "edit" ? getSelectedRowData() : {};

    const onCancel = () => {
        setICardcaseDrawer();
    }

    //表单提交
    const onSubmit = () => {
        formRef.current?.validateFields().then((val: ICardcaseFormFields) => {
            if (mode === "edit") {
                editCardcase({
                    ...formVal,
                    ...val,
                    id: formVal.id ?? ""
                })
            } else {
                addCardcase(val)
            }
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }


    const typeCodeChange = (value: string, option: ISelectOption) => {
        option && formRef.current?.setFieldsValue({ typeName: option.label, typeCode: option.value });
    }


    // //图片变更缓存保留  保留缓存及回显表单
    // const onSetFieldsValue = (formValues: { [key: string]: any }) => {
    //     formRef.current?.setFieldsValue(formValues);
    // }

    const formConfig: IYhForm<ICardcaseFormFields> = {
        formRef,
        labelCol: { span: 3 },
        formValues: formVal,
        items: [
            // {
            //     type: FormItemTypeEnum.Input,
            //     span: 24,
            //     fieldLabel: "头像",
            //     fieldName: "icon",
            // },
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "用户姓名",
                fieldName: "name",
                placeholder: "请输入",
                rules: [{ required: true, message: "请输入用户姓名" }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "电话",
                fieldName: "phone",
                span: 24,
                placeholder: "请输入",
                rules: [{ required: true, message: "请输入电话" }],
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "电话1",
                fieldName: "phone1",
                span: 24,
                placeholder: "请输入",
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "分组",
                fieldName: "typeCode",
                span: 24,
                options: dataGroupSource.map(item => ({ label: item.name ?? "", value: item.code ?? "" })),
                onSelectChange: typeCodeChange,
                rules: [{ required: true, message: "请选择分组" }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "微信号",
                fieldName: "wechat",
                span: 24,
                placeholder: "请输入",
            },
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "地址",
                fieldName: "address",
                placeholder: "请输入",
                rules: [{ required: true, message: "请输入地址" }],
            },
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "地址1",
                fieldName: "address1",
                placeholder: "请输入",
            },
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "邮箱",
                fieldName: "email",
                placeholder: "请输入",
            },
            // {
            //     type: FormItemTypeEnum.Input,
            //     span: 24,
            //     fieldLabel: "网址",
            //     fieldName: "site",
            //     placeholder: "请输入",
            // },
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "公司",
                fieldName: "company",
                placeholder: "请输入",
            },
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "部门",
                fieldName: "depName",
                placeholder: "请输入",
            },
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "职务",
                fieldName: "position",
                placeholder: "请输入",
            },
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "备注",
                fieldName: "note",
                placeholder: "请输入",
            },
            //带出字段
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "分组名称",
                fieldName: "typeName",
                hidden: true
            },
        ]
    };
    return (
        <YHDrawer
            {...{
                title: `名片${mode === "edit" ? "编辑" : "新增"}`,
                visible,
                onCancel,
                okText: "保存",
                onOk: onSubmit,
                width:800
            }}
        >
            <YhForm {...formConfig} />
        </YHDrawer>
    )
}
